import Routing from "./Routing";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
function App() {
  return (
    <>
      <div className="App">
        <ReactNotifications />
        <Routing />
      </div>
    </>
  );
}

export default App;
